import { Link } from 'react-router-dom';
import { Error } from '@mui/icons-material';
import { H4, Body1, Body2 } from '../../themes/typography';
import '../../styles/components/TicketError.css';

export default function TicketError() {
    return (
        <div className="ticket-booked-error-container">
            <div className="ticket-error-main-container">

                <section className="error-exclamation-section">
                    <Error style={{ color: 'var(--error-main-color)', fontSize: '3rem' }} />
                </section>

                <section className="payment-failed-title">
                    <H4>Payment Failed</H4>
                </section>

                <section className="payment-failed-desc">
                    <Body1>Unfortunately, the payment for this order has failed.</Body1>
                </section>

                <section className="payment-failed-contact-section">
                    <Body2>
                        If money has been deducted from your account, please reach out to us through our{' '}
                        <Link to="/contact-us">
                            <span style={{ color: 'var(--secondary-color)' }}>Contact Us</span>
                        </Link>{' '}
                        page and mention your order ID (eg., - ORDER_1457932)
                    </Body2>
                </section>

            </div>
        </div>
    );
}
